import { Component, ViewChild } from '@angular/core';
import { DateRangePopupComponent } from '@progress/kendo-angular-dateinputs';
import { ReportingDashboardService } from '../service/reporting-dashboard.service';
import { FacilityDD, ReportStatus } from '../model/report-status.model';
import { commonService } from 'src/app/services/common.service';
import moment from 'moment';

@Component({
  selector: 'app-reportingdashboard',
  templateUrl: './reportingdashboard.component.html',
  styleUrl: './reportingdashboard.component.scss'
})
export class ReportingdashboardComponent {

  todayDate = new Date();
  rangeSelectionValue_FirstGraph!: any;
  rangeSelectionValue_SecondGraph!: any;
  rangeSelectionValue_ThirdGraph!: any;
  rangeSelectionValue_FourthGraph!: any;

  @ViewChild('popup', { static: true }) popup!: DateRangePopupComponent;
  // @ViewChild('anchor', { static: true }) anchor!: ElementRef<any>;

  reportStatus!: ReportStatus;
  facilityDD!: FacilityDD[];
  priorityFacilityId: number = 3
  monthFacilityId: number = 3;
  acdBCSFacilityId: number = 3;
  average7daysFacilityId: number = 3;
  options = { year: 'numeric', month: '2-digit', day: '2-digit' };

  columnGraphType = "column";
  lineGraphType = "line";

  firstChartDataSet: any[] = [];
  secondChartDataSet: any[] = [];
  thirdChartDataSet: any[] = [];
  fourthChartDataSet: any[] = [];

  constructor(private reportingDashboardService: ReportingDashboardService, private commonService: commonService) {
    this.reportStatus = new ReportStatus();

    let LastSixMonthDate_Start = moment().subtract(6, 'months').startOf('month').toDate();
    let LastSixMonthDate_End = moment().endOf('day').toDate();

    this.rangeSelectionValue_FirstGraph = { startDate: new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 1), endDate: new Date() };
    this.rangeSelectionValue_SecondGraph = { startDate: LastSixMonthDate_Start, endDate: LastSixMonthDate_End };
    this.rangeSelectionValue_ThirdGraph = { startDate: moment().subtract(12, 'months').startOf('month').toDate(), endDate: moment().endOf('day').toDate() };
    this.rangeSelectionValue_FourthGraph = { startDate: LastSixMonthDate_Start, endDate: LastSixMonthDate_End };
  }

  ngOnInit() {
    this.getFacilityFieldMappings();
    this.getChangeRequestStatistics();
  }

  ngAfterViewInit() {
    if (this.popup?.anchor?.nativeElement) {
      this.popup.anchor.nativeElement.style.width = "200px";
      this.popup.anchor.nativeElement.style.height = "200px";
    }
  }

  rangeSelected(selectedRange: any, graphNumber: number) {
    if (selectedRange?.startDate != null && selectedRange?.endDate != null) {
      if (graphNumber == 1) {
        this.rangeSelectionValue_FirstGraph.startDate = selectedRange.startDate;
        this.rangeSelectionValue_FirstGraph.endDate = selectedRange.endDate;

        this.getPriorityComplianceStatistics();
      }
      else if (graphNumber == 2) {
        this.rangeSelectionValue_SecondGraph.startDate = selectedRange.startDate;
        this.rangeSelectionValue_SecondGraph.endDate = selectedRange.endDate;

        this.getMonthComplianceStatistics();
      }
      else if (graphNumber == 3) {
        this.rangeSelectionValue_ThirdGraph.startDate = selectedRange.startDate;
        this.rangeSelectionValue_ThirdGraph.endDate = selectedRange.endDate;

        this.getAcdBscComplianceStatistics();
      }
      else if (graphNumber == 4) {
        this.rangeSelectionValue_FourthGraph.startDate = selectedRange.startDate;
        this.rangeSelectionValue_FourthGraph.endDate = selectedRange.endDate;

        this.getAverageOpenDaysComplianceStatistics();
      }
    }
  }

  getChangeRequestStatistics() {
    this.reportingDashboardService.getChangeRequestStatistics().subscribe({
      next: (response: ReportStatus) => {
        if (response) {
          this.reportStatus = response;
        }
      }
    });
  }

  getFacilityFieldMappings() {
    this.reportingDashboardService.getFacilityFieldMappings().subscribe({
      next: (response: any) => {
        if (response) {
          this.facilityDD = response.filter((x: FacilityDD) => x.isActive);
          this.getPriorityComplianceStatistics();
          this.getMonthComplianceStatistics();
          this.getAcdBscComplianceStatistics();
          this.getAverageOpenDaysComplianceStatistics();
        }
      }
    });
  }

  getPriorityComplianceStatistics() {
    let facilities = this.facilityDD?.find((x: any) => x.id == this.priorityFacilityId)?.facilities ?? "";
    this.reportingDashboardService.getGraphData(facilities, this.rangeSelectionValue_FirstGraph?.startDate?.toLocaleDateString("en-US", this.options), this.rangeSelectionValue_FirstGraph?.endDate?.toLocaleDateString("en-US", this.options), 1).subscribe({
      next: (response: any) => {
        if (response) {
          this.firstChartDataSet = this.commonService.prepareChartData(response, this.columnGraphType);
        }
        else {
          this.firstChartDataSet = [];
        }
      }, error: () => {
        this.firstChartDataSet = [];
      }
    });
  }

  getMonthComplianceStatistics() {
    let facilities = this.facilityDD?.find((x: any) => x.id == this.monthFacilityId)?.facilities ?? "";

    this.reportingDashboardService.getGraphData(facilities, this.rangeSelectionValue_SecondGraph?.startDate?.toLocaleDateString("en-US", this.options), this.rangeSelectionValue_SecondGraph?.endDate?.toLocaleDateString("en-US", this.options), 2).subscribe({
      next: (response: any) => {
        if (response) {
          response.map((x: any) => {
            x.dataSeriesName = x.label;
          });
          this.secondChartDataSet = this.commonService.prepareChartData(response, this.columnGraphType);
        } else {
          this.secondChartDataSet = [];
        }
      }, error: () => {
        this.secondChartDataSet = [];
      }
    });
  }

  getAcdBscComplianceStatistics() {
    let facilities = this.facilityDD?.find((x: any) => x.id == this.acdBCSFacilityId)?.facilities ?? "";

    this.reportingDashboardService.getGraphData(facilities, this.rangeSelectionValue_ThirdGraph?.startDate?.toLocaleDateString("en-US", this.options), this.rangeSelectionValue_ThirdGraph?.endDate?.toLocaleDateString("en-US", this.options), 3).subscribe({
      next: (response: any) => {
        if (response) {
          this.thirdChartDataSet = this.commonService.prepareChartData(response, this.lineGraphType, true);
        } else {
          this.thirdChartDataSet = [];
        }
      }, error: () => {
        this.thirdChartDataSet = [];
      }
    });
  }

  getAverageOpenDaysComplianceStatistics() {
    let facilities = this.facilityDD?.find((x: any) => x.id == this.average7daysFacilityId)?.facilities ?? "";

    this.reportingDashboardService.getGraphData(facilities, this.rangeSelectionValue_FourthGraph?.startDate?.toLocaleDateString("en-US", this.options), this.rangeSelectionValue_FourthGraph?.endDate?.toLocaleDateString("en-US", this.options), 4).subscribe({
      next: (response: any) => {
        if (response) {
          response.map((x: any, index: number) => {
            x.dataSeriesName ??= "";
          });
          this.fourthChartDataSet = this.commonService.prepareChartData(response, this.lineGraphType);
        } else {
          this.fourthChartDataSet = [];
        }
      }, error: () => {
        this.fourthChartDataSet = [];
      }
    });
  }
}
